"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPrecision = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
function withPrecision(value, precision) {
    if (!value)
        return 0;
    try {
        var p = new bignumber_js_1.default(10).exponentiatedBy(precision);
        var num = new bignumber_js_1.default(value).multipliedBy(p);
        var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
        return Math.floor(num.toFixed(Math.max(0, (m[1] || "").length - m[2])) * 10000) / 10000;
    }
    catch (e) {
        console.log(e);
    }
}
exports.withPrecision = withPrecision;
